import type { Rule } from "../types";

const EVIDENCE = "amrein_2020_vit_d_window";

/**
 * Stubbed for v1: biomarker history isn't surfaced in the rules context yet.
 * Rule lives in the registry so the SPEC table is fully represented; once a
 * `biomarker` query is added to `RuleContext`, the body of `evaluate` becomes
 * `last_vit_d_age_days > 180 → fire`.
 */
export const vitDRecheckDue: Rule = {
  id: "vit_d_recheck_due",
  domain: "health.body",
  topics: ["vitamin_d", "biomarker_cadence"],
  evidence_refs: [EVIDENCE],
  title: () => "Vitamin D recheck due",
  evaluate() {
    return null;
  },
};
